import React, { useState } from 'react';
import Button from 'shared/components/Button';
import Input from 'shared/components/Input';
import { Auth } from 'aws-amplify';
import { Trans, useTranslation } from 'react-i18next';
import { Lock, Key } from 'lucide-react';
import { URLS } from 'configs';
import './Auth.scss';

const ResetPassword = ({ location }) => {
  const email = location.state?.email;
  const { t } = useTranslation();
  const [fetch, setFetch] = useState(false);
  const [error, setError] = useState();
  const [form, setForm] = useState({
    code: '',
    password: '',
    rpassword: '',
  });

  const onFormChange = ({ target }) => {
    const { name, value } = target;
    setForm({ ...form, [name]: value });
  };

  const onFormSubmit = async e => {
    setFetch(true);
    e.preventDefault();
    try {
      await Auth.forgotPasswordSubmit(email, form.code, form.password);
      window.location.assign(URLS.CONTACT);
    } catch (err) {
      setError(err.message);
      setFetch(false);
    }
  };

  const passNoMatch = form.rpassword && form.password !== form.rpassword;

  return (
    <>
      <div className='auth-welcome'>
        <h1 className='auth-welcome__title'>{t('title_reset_pass', 'Reset your password')}</h1>
        <p className='auth-welcome__subtitle'>
          <Trans i18nKey='sub_title_reset_pass'>
            We sent a code to <strong>{{ email: email }}</strong>. Enter it below to reset your password.
          </Trans>
        </p>
      </div>

      <div className='auth-card'>
        <form onSubmit={onFormSubmit}>
          <div className='auth-form-group'>
            <label className='auth-label'>
              <Key className='auth-icon' size={16} />
              {t('ph_code_from_email', 'Verification Code')} *
            </label>
            <Input
              type='number'
              name='code'
              onChange={onFormChange}
              value={form.code}
              placeholder={t('reset_code_placeholder', 'Enter code from email')}
              required
              className='mb-0'
              inputClassName='auth-input-field'
            />
          </div>
          <div className='auth-form-group'>
            <label className='auth-label'>
              <Lock className='auth-icon' size={16} />
              {t('ph_password', 'New Password')} *
            </label>
            <Input
              type='password'
              name='password'
              onChange={onFormChange}
              value={form.password}
              placeholder={t('signup_password_placeholder', 'Create a password')}
              required
              className='mb-0'
              inputClassName='auth-input-field'
            />
          </div>
          <div className='auth-form-group'>
            <label className='auth-label'>
              <Lock className='auth-icon' size={16} />
              {t('ph_repeat_password', 'Confirm Password')} *
            </label>
            <Input
              type='password'
              name='rpassword'
              onChange={onFormChange}
              value={form.rpassword}
              placeholder={t('signup_repeat_password_placeholder', 'Confirm your password')}
              errorText={passNoMatch ? t('error_password_no_match', "Passwords don't match") : ''}
              required
              className='mb-0'
              inputClassName='auth-input-field'
            />
          </div>
          {error && <div className='auth-error'>{error}</div>}
          <div className='auth-submit-wrapper'>
            <Button
              type='submit'
              withLoading={fetch}
              disabled={fetch || passNoMatch}
              className='btn-primary btn-block auth-submit-btn'
            >
              {t('btn_reset_pass', 'Reset password')}
            </Button>
          </div>
          <p className='auth-footer-text'>
            <a href={URLS.CONTACT} className='auth-link-bold'>
              {t('contact_us', 'Contact us')}
            </a>
          </p>
        </form>
      </div>
    </>
  );
};

export default ResetPassword;
